
import { IGeoLocation } from '@share/common-types';

export enum CondoLocationsEnum {
  Unspecified = 'Unspecified',
  GenericRegion = 'GenericRegion',
  GenericCondo = 'GenericCondo',
  NoAvailability = 'NoAvailability',
  PointOfInterest = 'PointOfInterest',
  Recents = 'Recents',
  State = 'State'
}

export enum LocationsTypes {
  Unspecified = 'Unspecified',
  Destination = 'City',
  Hotel = 'Hotel',
  Airport = 'Airport',
  Port = 'Port',
  Recents = 'Recents',
}

export interface ILocation {
  code: number;
  name: string;
  type?: LocationsTypes;
  realType?: LocationsTypes;
  isoCode?: string;
  
  geoLocation: IGeoLocation;
}

export enum CondoEngines {
  CONDO,
  WEEKS,
}

export interface ICondoLocation {
  id: string | null | undefined;
  name: string | null | undefined;
  region?: string;
  keywords?: string[];

  locationType: CondoLocationsEnum | null | undefined;
  realType?: CondoLocationsEnum;
  total?: number;
  geoLocation?: IGeoLocation;

  engine?: CondoEngines;
}
